/**
 *Created by jmmartinez on 3/8/18
 * v.1.1  26/03/2019 Añadida propiedad status.
 * v.1.2  28/03/2019 Añadido método doDelete y comentado this.state en el catch
 * v.1.3  24/04/2019 Añadido abir ventana con pdf
 *                   Añadido descargar los xlsx
 * v.1.4  06/05/2019 Añadido callbackError en doGet, doPost, doDelete y procesar.
 * v.1.5  20/11/2019 Añadida numTotalElements.
 **/

import {refreshSession} from "./SessionUtils";
import {getFormattedDateTimeAhoraForFile} from "./DateUtils"

class ClienteRestful {

    constructor(url) {
        this.token = '';
        this.resultado = {};
        this.exito = false;
        this.esjson = false;
        this.errores = '';
        this.url = url;
        this.timeout = 3000;
        this.status= 0;
        this.fileName= null;
        this.numTotalElements= 0;
    }

    setUrl(url) {
        this.url = url;
        return this;
    }

    setToken(token) {
        this.token = token;
        return this;
    }

    getResultado() {
        return this.resultado;
    }

    getErrores() {
        return this.errores;
    }



    isExito() {
        return this.exito;
    }

    getStatus() {
        return this.status;
    }

    getNumTotalElements() {
        return this.numTotalElements;
    }

    doGet(callback, callbackError) {
        this.procesar("GET", null, callback, callbackError);
    }

    doPost(entity, callback, callbackError) {
        this.procesar("POST", entity, callback, callbackError);
    }

    doDelete(callback, callbackError) {
        this.procesar("DELETE", null, callback, callbackError);
    }

    //exposedHeaders: ['numele'],

    procesar(metodo, body, callback, callbackError){

        refreshSession();

        let headers = new Headers({
            'Accept': 'text/plain, application/json, application/pdf, application/vnd.ms-excel, application/octet-stream, application/zip, image/svg+xml, application/xlsx',
            'Content-Type': 'application/json'

        });



        if (this.token !== '') {
            headers.set("token", this.token);
        }

        let request = {
            method: metodo,
            headers: headers,
            //mode: 'no-cors',
        }

        if (metodo !== "GET" && body !== undefined) {
            request['body'] = JSON.stringify(body);
        }

        fetch(this.url, request)
            .then( response => {
                console.log(response);
                if (response) {
                    this.status = response.status;
                }
                if (response.status === 200) {
                    this.exito= true;
                    this.numTotalElements= response.headers.get('num-total-elements');
                    const contentType = response.headers.get('Content-type');
                    if (contentType && (contentType.toLowerCase().includes("application/json"))) {
                        this.esjson= true;
                        return response.json();
                    } else{
                        if (contentType && (contentType.toLowerCase().includes( "image/svg+xml"))) {
                            response.text().then((text) => {
                                callback && callback(text);
                            })
                        }
                        else {
                            if (contentType && (contentType.toLowerCase().includes( "application/pdf"))) {
                                response.blob().then( (blob) => {
                                    console.log(blob);
                                    var objectURL = URL.createObjectURL(blob);
                                    window.open(objectURL);
                                })
                            }
                            else{
                                if (contentType && (contentType.toLowerCase().includes( "application/xlsx"))) {
                                    response.blob().then( (blob) => {
                                        console.log(blob);
                                        let newFileName= this.fileName ? this.fileName : createFileName("xlsx");
                                        downloadBlob(blob, newFileName);
                                    })
                                }
                                else {
                                    this.esjson = false;
                                    callback && callback(response)
                                }
                            }
                        }
                    }
                }else {
                    console.log("ERROR");
                    console.log(response);
                    this.exito= false;
                    response.text().then(body => {
                        this.errores= body;
                        callback && callback(body);
                    }).catch(error => {
                        this.errores= "ERROR INDETERMINADO";
                    });
                }
            })
            .then( json  => {
                if (this.exito && this.esjson) {
                    callback && callback(json);
                }
            })
            .catch(function(err) {
                //this.status= 0; <--- aqui no existe this 8(
                console.log("ERROR");
                console.log(err);
                callbackError && callbackError();
            });

    }

}

function downloadBlob(blob, fileName) {
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

function createFileName(extension) {
    let ahoraCadena= getFormattedDateTimeAhoraForFile();
    return ahoraCadena + "." + extension;

}

export default ClienteRestful;